import React from "react";

export function marginLeft(space) {
    return {marginLeft: `${8 * (space || 0)}px`}
}

export function marginRight(space) {
    return {marginRight: `${8 * (space || 0)}px`}
}

export function marginTop(space) {
    return {marginTop: `${8 * (space || 0)}px`}
}

export function marginBottom(space) {
    return {marginBottom: `${8 * (space || 0)}px`}
}

export function paddingTop(space) {
    return {paddingTop: `${8 * (space || 0)}px`}
}

export function paddingBottom(space) {
    return {paddingBottom: `${8 * (space || 0)}px`}
}

export function scrollOutView() {
    return {
        display: 'flex',
        flexDirection: 'column',
        height: `${window.innerHeight}px`,
    }
}


export function itemView(contentView, marginTopNum = 3) {
    let style = Object.assign(marginTop(marginTopNum), {
        padding: '16px 29px 16px 16px',
        background: '#fff',
        color: '#666'
    })
    return <div className={'color666666'} style={style}>{contentView}</div>
}

